import React, { useEffect, useState } from 'react';
import { CourseManageContent } from './course-manage-content';
import { CourseManageSidebar } from './course-manage-sidebar';
import { useClient } from 'jsonapi-react';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { t } from 'i18next';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export function CourseManage({ selectedTab }) {
  const [course, setCourse] = useState();
  const [loading, setLoading] = useState(false);
  const client = useClient();
  const [currentModuleId, setCurrentModuleId] = useState();
  const [count, setCount] = useState(0);
  const { courseId, moduleId } = useParams();

  const getCourse = async () => {
    setLoading(true);
    const { data, error } = await client.fetch(`/courses/${parseInt(courseId)}?detailed=true`);
    if (error) {
      toast.error(t('toast.errorLoadCourseData'));
    } else {
      setCourse(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCourse();
  }, [count]);

  useEffect(() => {
    if (moduleId !== 'm') {
      setCurrentModuleId(moduleId);
    }
  }, [course, moduleId]);

  return (
    <Dashboard>
      <CourseManageSidebar
        selectedTab={selectedTab}
        setCount={setCount}
        loading={loading}
        currentModuleId={currentModuleId}
        setCurrentModuleId={setCurrentModuleId}
        course={course}
      />

      <DashboardContent
        viewMode="create"
        className="md:!px-0 md:!py-0"
      >
        <div className="new-questions">
          <CourseManageContent
            selectedTab={selectedTab}
            courseId={courseId}
            currentModuleId={currentModuleId}
            course={course}
          />
        </div>
      </DashboardContent>
    </Dashboard>
  );
}
